import { isMobileOrTablet } from "../../Views/MobileClassRenderer";

export const ActionPointLinkKind = {
  INTERNAL_PAGE: 0,
  EXTERNAL_PAGE: 1,
  MODAL: 2,
  DOCUMENT: 3,
  IMAGE: 4,
  VIRTUAL_MEETING_ROOM: 5,
  VIRTUAL_SPEED_NETWORKING: 6,
  VIDEO: 7,
};

export const ActionPointIconKind = {
  NONE: 0,
  IMAGE: 1,
  VIDEO: 2,
  PAGE: 3,
  FILE: 4,
  CAMERA: 5,
  LIVE: 6,
  GLOBE: 7,
};

export function getIconCSSClass(iconKind, linkKind) {
  let contentKind = "";
  if (iconKind === ActionPointIconKind.IMAGE) {
    contentKind = "image";
  }
  if (iconKind === ActionPointIconKind.VIDEO) {
    if (
      linkKind === ActionPointLinkKind.VIRTUAL_MEETING_ROOM ||
      linkKind === ActionPointLinkKind.VIRTUAL_SPEED_NETWORKING
    ) {
      contentKind = "whereby";
    } else {
      contentKind = "video";
    }
  }
  if (iconKind === ActionPointIconKind.PAGE) {
    if (linkKind === ActionPointLinkKind.EXTERNAL_PAGE) {
      contentKind = "link";
    } else {
      contentKind = "htmlLink";
    }
  }
  if (iconKind === ActionPointIconKind.FILE) {
    contentKind = "document";
  }
  if (iconKind === ActionPointIconKind.CAMERA) {
    contentKind = "camera";
  }
  if (iconKind === ActionPointIconKind.LIVE) {
    contentKind = "live";
  }
  if (iconKind === ActionPointIconKind.GLOBE) {
    contentKind = "globe";
  }
  if (iconKind === ActionPointIconKind.NONE) {
    contentKind = isMobileOrTablet() ? "none--mobile" : "none";
  }

  return `view__links__icon--${contentKind}`;
}
